let baseUrl = ''
let dev = false
if (process.env.NODE_ENV === 'production') {
  baseUrl = '/'
} else {
  baseUrl = 'http://otomo.local/'
  dev = true
}

export const url = baseUrl
export const devMode = dev
export const API_URL = process.env.VUE_APP_OTOMO_API_HOST
export const MEDIA_URL = process.env.VUE_APP_OTOMO_MEDIA_HOST_URL



// WEBPACK FOOTER //
// ./src/config.js